import request from '../helpers'
import store from '@/store'
const state = {
  loading: false,
  current_entity: {
    'truck':{},'package':{},'user':{},'freightfowarders':{},'driver':{},'mobilePhone':{},'deliveryAddress':{},'language':{},'wayBill':{},'settings':{},'deliveryAddressWayBill':{},'geoRegion':{},'pending_wayBill':{}, 'notification':{}, 'driverStop':{}
  },
  entities:{
    'truck':[],'package':[],'user':[],'freightfowarders':{},'driver':[],'mobilePhone':[],'deliveryAddress':[],'language':[],'wayBill':[],'settings':[],'deliveryAddressWayBill':[],'geoRegion':[],'pending_wayBill':[], 'notification':[], 'driverStop':[]
  },
  pageCount:{
    'notification':0
  },
  search:{},
  selected_search_entity:{'truck':{},'package':{},'user':{},'freightfowarders':{},'driver':{},'mobilePhone':{},'deliveryAddress':{},'language':{},'wayBill':{},'settings':{},'deliveryAddressWayBill':{},'geoRegion':{},'pending_wayBill':{},'notification':{}, 'driverStop':{}}
}

const mutations = {
  CHANGE_LOADING_STATE(state, loading) {
    state.loading = loading
  },
  SET_ENTITY (state, entity, name) {
    if (entity != null) {
      state.current_entity[name] = entity
    } else {
      state.current_entity[name] = {}
    }
  },
  UPDATE_ENTITIES (state, payload) {
      try {
        var entities = payload.entities
        var name = payload.name
        if(!Array.isArray(state.entities[name])) state.entities[name] = []
        state.entities[name] = entities
        if(payload.pageCount !== undefined) {
          state.pageCount[name] = payload.pageCount
        }
      }
      catch(e) {
        console.log(`EXCEPTION!!! ${e}`)
      }
  },
  UPDATE_SEARCH_ENTITIES(state, payload) {
    var entities = payload.entities
    var name = payload.name
    if(state.search[name] !== undefined || !Array.isArray(state.search[name])) state.search[name] = []
    state.search[name] = entities
    state.loading = false
  },
  APPEND_UPDATE_ENTITY (state, entity) {
    try {
      var name = entity.entity_name
      var e = state.entities[name]
      if(e === undefined || !Array.isArray(e)) {
          state.entities[name] = [];
      }
      e = state.entities[name]
      var currentIndex = e.findIndex(c => c.id == entity.id)
      if (currentIndex == -1)
        state.entities[name].push(entity)
      else
        state.entities[name].splice(currentIndex, 1, entity) // necessary to force vue to detect the change
      state.current_entity[name] = entity;
    }
    catch(e) {
      console.log('EXCEPTIONS !!' + e)
    }
  },
  DELETE_ENTITY (state, entity) {
    var name = entity.entity_name
    var currentIndex = state.entities[name].findIndex(c => c.id == entity.id)
    if (currentIndex != -1)
      state.entities[name].splice(currentIndex, 1)
  },
  DELETE_ALL_ENTITIES (state, name) {
      state.entities[name].splice(0)
  },
  CLEAR_ALL_ENTITIES (state, name) {
      state.entities[name].splice(0)
  }
}

const actions = {
  getEntities({ commit }, name) {
    var FFId = localStorage.getItem('selectedFFId');
    localStorage.setItem('selectedFFId',0);
    
    var WBStatusId = localStorage.getItem('selectedWBStatusId');
    localStorage.setItem('selectedWBStatusId',0);
    
    if(FFId>0 || WBStatusId>0){
      
      if(name.includes("pending_")) {
        var name_arr = name.split('_');
        var named = name_arr[1]
        return request({ commit: commit, method: 'get', url: `${named}/GetPendingListByFF?freightForwarderId=` + FFId + '&StatusId=' + WBStatusId, successCallback: entities => {
          var payload = {entities:entities, name: name}
          commit('UPDATE_ENTITIES', payload);
        }});
      } 
      return request({ commit: commit, method: 'get', url: `${name}/GetListByFF?freightForwarderId=` + FFId + '&StatusId=' + WBStatusId, successCallback: entities => {
        //console.log(entities)
        var payload = {entities:entities, name: name}
        commit('UPDATE_ENTITIES', payload);
      }});
    }
    if(name.includes("pending_")) {
      var name_arr = name.split('_');
      var named = name_arr[1]
      return request({ commit: commit, method: 'get', url: `${named}/pendingList`, successCallback: entities => {
        var payload = {entities:entities, name: name}
        commit('UPDATE_ENTITIES', payload);
      }});
    }
    return request({ commit: commit, method: 'get', url: `${name}/list`, successCallback: entities => {
      //console.log(entities)
      var payload = {entities:entities, name: name}
      commit('UPDATE_ENTITIES', payload);
    }});
  },
  getPaginatedEntities({ commit },requestPayload) {
    var name = requestPayload.name
    var page = requestPayload.page
    var perPage = requestPayload.perPage
    var search = requestPayload.search
    return request({ commit: commit, method: 'get', url: `${name}/paginatedList?page=${page}&perPage=${perPage}&search=${search}`, successCallback: entities => {
      console.log(entities)
      var payload = {entities:entities.results, name: name, pageCount:entities.pageCount}
      commit('UPDATE_ENTITIES', payload);
    }});
  },
  getPendingEntities({ commit }, name) {
    console.log(name)
  },
  approvalResponse({ commit }, data) {
    var name = data.entity_name;
    return request({ commit: commit, method: 'get', url: `${name}/ApprovalResponse?waybillId=${data.id}&creatorId=${data.user.id}&approval=${data.entity_status}`, successCallback: entities => {
      console.log(entities)
      var payload = {entities:entities, name: name}
      commit('UPDATE_ENTITIES', payload);
    }});
  },
  saveEntity({ commit }, data) {
    var name = data.entity_name;
    if(name.includes("pending_")) {
      var name_arr = name.split('_');
      var name = name_arr[1]
    }
    return request({ method: 'post', url: `${name}`, data: data, successCallback: entity => {
      console.log(entity)
      var e = undefined
      if(entity.value !== undefined) e = entity.value
      if(entity.data !== undefined) e = entity.data
      else e = entity
      e.entity_name = name

      var canProceed = true
      if (entity.success !== undefined) {
        if (entity.success === false) {
          canProceed = false
        }
      }
      if(canProceed) {
        commit('APPEND_UPDATE_ENTITY', e); 
        return e
      }
      else {
        throw(entity.message)
      }
    }});
  },
  deleteEntity({ commit }, data) {
    var name = data.entity_name;
    if(name.includes("pending_")) {
      var name_arr = name.split('_');
      var name = name_arr[1]
    }
    return request({ commit: commit, method: 'delete', url: `${name}/${data.id}`, successCallback: entity => {
      entity.entity_name = name
      commit('DELETE_ENTITY', entity);
    }});
  },
  deleteAllEntities({ commit }, data) {
    var name = data;
    if(name.includes("pending_")) {
      var name_arr = name.split('_');
      var name = name_arr[1]
    }
    return request({ commit: commit, method: 'post', url: `${name}/deleteAll`, successCallback: entity => {
      commit('DELETE_ALL_ENTITIES', name);
    }});
  },
  clearAllEntities({ commit }, data) {
    var name = data;
    if(name.includes("pending_")) {
      var name_arr = name.split('_');
      var name = name_arr[1]
    }
    return request({ commit: commit, method: 'post', url: `${name}/clearAll`, successCallback: entity => {
      commit('CLEAR_ALL_ENTITIES', name);
    }});
  },
  searchEntities({commit}, data) {
    var name = data.entity_name
    var search = data.query
    if(name.includes("pending_")) {
      var name_arr = name.split('_');
      var name = name_arr[1]
    }
    state.loading = true
    console.log(`posting ${JSON.stringify(data)}`)
    return request({ commit: commit, method: 'POST', url: `${name}/search`,data:data, successCallback: entities => {
      var payload = {entities:entities, name:name}
      commit('UPDATE_SEARCH_ENTITIES', payload);
    }});
  }
}

const getters = {
  allowDelete(state, name) {
    return state.entities[name] !== undefined && state.entities[name].length > 1
  },
  currentEntity(name) {
    return state.current_entity[name]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
